import { sampleOrganization, sampleGM } from '@tumelo/shared'
import { OrganizationService } from './OrganizationService'

export const OrganizationServiceMock: OrganizationService = {
  batchGetOrganizations: async (identifiers) => identifiers.map(() => sampleOrganization()),
  listGeneralMeetings: async () => [sampleGM()],
}
